module.exports = __webpack_public_path__ + "img/q2.97c5933b.svg";